<template>
    <ion-page id="main">
      <ion-header :translucent="true">
        <ion-toolbar>
          <ion-title>Edward Turner | Data & AI Leader</ion-title>
        </ion-toolbar>
      </ion-header>

        <div class="primary" id="home">
          <Home />
        </div>

        <div class="secondary" id="expertise">
          <Expertise />
        </div>

        <div class="primary" id="about">
          <About />
        </div>

        <div class="secondary" id="experiences">
          <Experiences />
        </div>

        <div class="primary" id="testimonies">
          <Testimonies />
        </div>

        <ion-footer>
          <Contact />
        </ion-footer>
    </ion-page>

</template>

<script>
import Home from './components/Home.vue'
import About from './components/About.vue'
import Expertise from './components/Expertise.vue'
import Testimonies from './components/Testimonies.vue'
import Experiences from './components/Experiences.vue';
import Contact from '@/components/Contact.vue';

import { IonHeader, IonTitle, IonToolbar, IonPage, IonFooter } from '@ionic/vue';

export default {
  name: 'App',
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    Home,
    About,
    Expertise,
    Testimonies,
    Experiences,
    Contact,
    IonFooter
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.primary {
  background-color: #023047;
  color: #F4F3EE;
}

.secondary {
  background-color: #816E94;
  color: #F4F3EE;
}

ion-card{
    display: flex;
    flex-direction: column;
    width: 100% !important;
    margin: 0 !important;
    height: 100% !important;
  }

</style>
